import React from 'react';
import { SelectionType } from '$/GraphQL/schema/types';
import {
  InteractionAccordionPanelProps,
  InteractionModalComponentProps,
} from '$/components/Interactions/types';
import Form from '$/components/ui/Form';

import Dropdown from '$/components/ui/Input/Basics/Dropdown';

const pollTypes = [
  {
    value: SelectionType.Single,
    text: 'Single select',
  },
  {
    value: SelectionType.Multi,
    text: 'Multi select',
  },
];

const PollSettings: (props: InteractionModalComponentProps) => InteractionAccordionPanelProps[] = ({
  interaction,
}) => {
  return [
    {
      key: 'Settings',
      active: true,
      title: { content: <Form.AccordionTitle title={'Settings'} /> },
      content: {
        content: (
          <>
            <Form.FieldLabel title='Poll type' className='mt-1e' />
            <Form.Field
              name='details.selectionType'
              component={
                <Dropdown className='flex-grow' options={pollTypes} placeholder='Single select' />
              }
              defaultValue={interaction.details?.selectionType || SelectionType.Single}
            />
          </>
        ),
      },
    },
  ];
};

export default PollSettings;
